'use client';

import { c as _c } from "react/compiler-runtime";
import { AbsoluteCenter, Menu as ChakraMenu, Portal } from '@chakra-ui/react';
import * as React from 'react';
import { LuCheck, LuChevronRight } from 'react-icons/lu';
interface MenuContentProps extends ChakraMenu.ContentProps {
  portalled?: boolean;
  portalRef?: React.RefObject<HTMLElement>;
}
export const MenuContent = React.forwardRef<HTMLDivElement, MenuContentProps>(function MenuContent(props, ref) {
  const $ = _c(11);
  let portalRef;
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      portalled: t0,
      portalRef,
      ...rest
    } = props);
    $[0] = props;
    $[1] = portalRef;
    $[2] = rest;
    $[3] = t0;
  } else {
    portalRef = $[1];
    rest = $[2];
    t0 = $[3];
  }
  const portalled = t0 === undefined ? true : t0;
  const t1 = !portalled;
  let t2;
  if ($[4] !== ref || $[5] !== rest) {
    t2 = <ChakraMenu.Positioner><ChakraMenu.Content ref={ref} {...rest} /></ChakraMenu.Positioner>;
    $[4] = ref;
    $[5] = rest;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== portalRef || $[8] !== t1 || $[9] !== t2) {
    t3 = <Portal disabled={t1} container={portalRef}>{t2}</Portal>;
    $[7] = portalRef;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
});
export const MenuArrow = React.forwardRef<HTMLDivElement, ChakraMenu.ArrowProps>(function MenuArrow(props, ref) {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ChakraMenu.ArrowTip />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props || $[2] !== ref) {
    t1 = <ChakraMenu.Arrow ref={ref} {...props}>{t0}</ChakraMenu.Arrow>;
    $[1] = props;
    $[2] = ref;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
});
export const MenuCheckboxItem = React.forwardRef<HTMLDivElement, ChakraMenu.CheckboxItemProps>(function MenuCheckboxItem(props, ref) {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AbsoluteCenter axis="horizontal" insetStart="4" asChild={true}><ChakraMenu.ItemIndicator><LuCheck /></ChakraMenu.ItemIndicator></AbsoluteCenter>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props || $[2] !== ref) {
    t1 = <ChakraMenu.CheckboxItem ps="8" ref={ref} {...props}>{t0}{props.children}</ChakraMenu.CheckboxItem>;
    $[1] = props;
    $[2] = ref;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
});
export const MenuRadioItem = React.forwardRef<HTMLDivElement, ChakraMenu.RadioItemProps>(function MenuRadioItem(props, ref) {
  const $ = _c(10);
  let children;
  let rest;
  if ($[0] !== props) {
    ({
      children,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AbsoluteCenter axis="horizontal" insetStart="4" asChild={true}><ChakraMenu.ItemIndicator><LuCheck /></ChakraMenu.ItemIndicator></AbsoluteCenter>;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== children) {
    t1 = <ChakraMenu.ItemText>{children}</ChakraMenu.ItemText>;
    $[4] = children;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== ref || $[7] !== rest || $[8] !== t1) {
    t2 = <ChakraMenu.RadioItem ps="8" ref={ref} {...rest}>{t0}{t1}</ChakraMenu.RadioItem>;
    $[6] = ref;
    $[7] = rest;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
});
export const MenuItemGroup = React.forwardRef<HTMLDivElement, ChakraMenu.ItemGroupProps>(function MenuItemGroup(props, ref) {
  const $ = _c(11);
  let children;
  let rest;
  let title;
  if ($[0] !== props) {
    ({
      title,
      children,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = rest;
    $[3] = title;
  } else {
    children = $[1];
    rest = $[2];
    title = $[3];
  }
  let t0;
  if ($[4] !== title) {
    t0 = title && <ChakraMenu.ItemGroupLabel userSelect="none">{title}</ChakraMenu.ItemGroupLabel>;
    $[4] = title;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== children || $[7] !== ref || $[8] !== rest || $[9] !== t0) {
    t1 = <ChakraMenu.ItemGroup ref={ref} {...rest}>{t0}{children}</ChakraMenu.ItemGroup>;
    $[6] = children;
    $[7] = ref;
    $[8] = rest;
    $[9] = t0;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
});
export interface MenuTriggerItemProps extends ChakraMenu.ItemProps {
  startIcon?: React.ReactNode;
}
export const MenuTriggerItem = React.forwardRef<HTMLDivElement, MenuTriggerItemProps>(function MenuTriggerItem(props, ref) {
  const $ = _c(10);
  let children;
  let rest;
  let startIcon;
  if ($[0] !== props) {
    ({
      startIcon,
      children,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = rest;
    $[3] = startIcon;
  } else {
    children = $[1];
    rest = $[2];
    startIcon = $[3];
  }
  let t0;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LuChevronRight />;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== children || $[6] !== ref || $[7] !== rest || $[8] !== startIcon) {
    t1 = <ChakraMenu.TriggerItem ref={ref} {...rest}>{startIcon}{children}{t0}</ChakraMenu.TriggerItem>;
    $[5] = children;
    $[6] = ref;
    $[7] = rest;
    $[8] = startIcon;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
});
export const MenuRadioItemGroup = ChakraMenu.RadioItemGroup;
export const MenuContextTrigger = ChakraMenu.ContextTrigger;
export const MenuRoot = ChakraMenu.Root;
export const MenuSeparator = ChakraMenu.Separator;
export const MenuItem = ChakraMenu.Item;
export const MenuItemText = ChakraMenu.ItemText;
export const MenuItemCommand = ChakraMenu.ItemCommand;
export const MenuTrigger = ChakraMenu.Trigger;